import { PortfolioRepo as portfolioRepo } from '@services/portfolio.repo';
import { PortfolioUtilities as portfolioUtilities } from '@common/portfolio.utilities';
import { portfolioSelectorService } from '../../portfolioSelector';
import * as echarts from 'echarts';
import { Array } from 'es6-shim';

class PortfolioInternationalEquityController implements angular.IOnInit {

  public equityItems: any;
  public marketValue: any;
  public equitiesTotal: any = 0;
  chartEquityHeight: any;
  public selectedCurrency: string;

  public equityPieChart : any;
  public equityPieChartOptions : any;
  public equityPieChartData : any;
  

  /** @ngInject */
  constructor(private portfolioRepo: portfolioRepo, private portfolioUtilities: portfolioUtilities, private portfolioSelectorService : portfolioSelectorService,
              private $timeout: ng.ITimeoutService, $scope: angular.IScope, private notifyjs) {

    var that = this;

    this.portfolioSelectorService.registerCallback('portfolio.international.equity', () => { this.updateData() }); // Need to wrap it in a fat arrow functiom to get the correctly scoped this

  }

  $onInit() {
    this.updateData();
  }

  public formatCurrency(currencyCode: string) {
    if(!this.portfolioSelectorService.isLoading){
      return this.portfolioUtilities.formatCurrency(currencyCode);
    }else{
      return "";
    }
  }

  public scrollToElement(elementId: string) {
    var that = this;
    this.$timeout(function () { that.portfolioUtilities.scrollToElement(elementId); }, 220);
  }

  public getMarketValueInMUR(equity: any) {
    return equity.marketValueMUR;
  }

  public getMarketValueInDisplayCurrency(equity: any) {
    return equity.marketValueDisplayCurrency;
  }

  public getEquityPercentage(equity: any) {
    return (this.getMarketValueInMUR(equity) / this.equitiesTotal) * 100;
  }
  
  public initialisePieChart () {
    // need to put the initialisation of the pie chart in a function because the dom element is not available till 
    // the time you have clicked on the pie chart tab.
    var that = this;
    that.equityPieChart = echarts.init(document.getElementById('equity-pie-chart'));
    that.equityPieChartOptions = {
      tooltip: {
        trigger: 'item',
        formatter: "{b} : {d}%"
      },
      color : ["#cc501e","#ff6526","#ff8351", "#ffa27c"],
      series: {
        type: 'pie',
        radius: ['40%', '70%'],
        center: ['50%', '50%'],
        labelLine: {
          normal: {
            show: true
          }
        },
        data: that.equityPieChartData
      }
      
    }
    that.equityPieChart.setOption(that.equityPieChartOptions); 

  }


  updateData() {
    // Equity data
    let that = this;
    that.selectedCurrency = this.portfolioSelectorService.getSelectedCurrency();
    this.portfolioSelectorService.setIsLoading(true);

    that.portfolioRepo.getPortfolioEquityItems(that.selectedCurrency, 'INTERNATIONAL', this.portfolioSelectorService.getSelectedPortfolios())
      .then((val) => {
        this.equityItems = val.data;

        that.scrollToElement('equity');
        
        that.equityPieChartData = new Array();
        for (var s of this.equityItems) {
          this.equitiesTotal += this.getMarketValueInMUR(s);

          that.equityPieChartData.push({
            name : s.equityItem.name,
            value : this.getMarketValueInMUR(s)
          });
        }
        this.portfolioSelectorService.setIsLoading(false);
      })
      .catch((err) => {
        this.portfolioSelectorService.setIsLoading(false);
        this.notifyjs("The equity data for the selected portfolios could not be loaded. Please try again later or contact the System Administrator.", "error");
      })
  }
}

export const portfolioInternationalEquity: angular.IComponentOptions = {
  template: require('../portfolio.international.equity/portfolio.international.equity.html'),
  controller: PortfolioInternationalEquityController
}




// WEBPACK FOOTER //
// ./src/app/portfolio/portfolio.international/portfolio.international.equity/portfolio.international.equity.ts